module.exports = __webpack_public_path__ + "img/Middle-2-Bevel-Attachment-37.121097b0.png";